import { emitterProps, globalEmitter } from './emitter-event'

export class NativeFetcher {
  async get(endpoint) {
    const init = {
      method: 'GET'
    }

    const response = await fetch(endpoint, init)
    if (response.ok) return await response.json()
    else this.error(response)
  }

  async post(endpoint, body) {
    const init = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: typeof body === 'string' ? body : JSON.stringify(body)
    }

    const response = await fetch(endpoint, init)
    if (response.ok) return await response.json()
    else this.error(response)
  }

  async error(response, options = {}) {
    const { silent } = options
    const error = await response.json()

    if (silent) {
      console.error('Cart Error:', error.description)
    } else {
      globalEmitter.emit(emitterProps.notice.global, {
        type: 'error',
        content: error.description
      })
    }
  }
}

export const fetchData = () => {}
export const postData = () => {}
